export default __webpack_public_path__ + "4c1bed1050c5bda38ba6c88c027b986e.png";